import { useEffect } from "react";
import { PREVIOUS_URL_PATH, REQUESTED_SERVICES_PATH } from "../../../../../constants/env";
import HeaderV2 from "../../header-v2";
import useHeaderV2Store from "../../hooks/use-header-v2-store.hook";
import type { IHeaderV2LayoutStore } from "../../stores/header-v2-layout-store";
import { HeaderV2LayoutAction } from "../../stores/header-v2-layout-store";

function CompletedProcedurePageHeader(): JSX.Element {
  const { setHeaderV2LayoutStore } = useHeaderV2Store();

  useEffect(
    function setInitialStateHeader() {
      const headerOptions: IHeaderV2LayoutStore = {
        backButton: {
          url: PREVIOUS_URL_PATH,
          defaultBackUrl: REQUESTED_SERVICES_PATH,
        },
        actions: [HeaderV2LayoutAction.chatWithOperator],
      };

      setHeaderV2LayoutStore(headerOptions);
    },
    [setHeaderV2LayoutStore]
  );

  return <HeaderV2 />;
}

export default CompletedProcedurePageHeader;
